<template lang="pug">
ValidationProvider.p-relative(
  v-slot="{ errors, invalid }"
  tag="div"
  name="weekdays"
  rules="required"
)
  AppIntervalDayPicker#weekdays(
    mode="week"
    multiple
    :value="value"
    :disabled="isJobInThePast"
    @input="onWeeklyInput"
  )
  .a-errors(
    v-show="invalid || hasApiErrors"
    :class="{ 'has-error': invalid || hasApiErrors }"
  )
    template(v-if="errors && errors.length")
      span.help-block(
        v-for="(err, index) in errors"
        :key="`${err}-${index}`"
      ) weekdays {{ err }}
    template(v-if="hasApiErrors")
      span.help-block(
        v-for="(err, index) in apiErrors.weekdays"
        :key="`${err}-${index}`"
      ) weekdays {{ err }}
</template>

<script>
import { get } from 'lodash-es';

export default {
  name: 'RecurringJobWeeklyInput',
  inject: ['isJobInThePast'],
  props: {
    date: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      required: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    hasApiErrors() {
      const apiErrors = get(this.errors, 'weekdays', []);

      return !!apiErrors.length;
    },
    dateDay() {
      return this.date.day();
    },
  },
  watch: {
    date: {
      immediate: true,
      handler(newDate, oldDate) {
        // On mounting it will default to the `newDate`
        const day = oldDate ? oldDate.day() : newDate.day();
        const newValue = new Set(this.value);

        newValue.delete(day);

        this.onWeeklyInput([...newValue]);
      },
    },
  },
  methods: {
    onWeeklyInput(newValue = []) {
      // Force the date "day" to be selected always
      this.$emit('input', [...new Set([...newValue, this.dateDay])]);
    },
  },
};
</script>
